import { Grid, LinearProgress, Typography } from '@mui/material'
import { styled } from '@mui/system'

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  boxShadow: 'inset 0px 0px 5px rgba(0, 0, 0, 0.25)',
  '&.MuiLinearProgress-colorPrimary': {
    backgroundColor: theme.palette.grey?.[50] || '#f5f5f5'
  },
  '& .MuiLinearProgress-bar': {
    background: 'linear-gradient(81.59deg, #A6813C -6.65%, #F2E3B3 50.89%, #BFA75E 110.5%)',
    borderRadius: 5,
    backgroundColor: theme.palette.success?.main || '#4caf50'
  },
  '@global': {
    '.complete div': {
      backgroundColor: theme.palette.success?.main || '#4caf50'
    }
  }
}))

type LinearProgressBarProps = {
  progress: number
  vip?: boolean
}

function LinearProgressBar({ progress, vip }: LinearProgressBarProps) {
  const safeProgress = typeof progress === 'number' ? progress : 0

  return (
    <Grid container spacing={1} justifyContent="space-between" alignItems="center" style={{ marginBottom: 2 }}>
      <Grid item xs={8} sm={9}>
        {vip ? (
          <BorderLinearProgress variant="determinate" value={safeProgress} className={safeProgress === 100 ? 'complete' : ''} />
        ) : (
          <BorderLinearProgress variant="determinate" value={safeProgress} className={safeProgress === 100 ? 'complete' : ''} />
        )}
      </Grid>
      <Grid item xs={4} sm={3}>
        <Typography
          sx={[
            vip
              ? {
                  backgroundImage: 'linear-gradient(89.97deg, #D5B385 -12.76%, #B49568 113.26%)',
                  fill: '#B49568',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }
              : {
                  color: 'grey.800',
                  '&.complete': {
                    color: 'success.main'
                  }
                }
          ]}
          align="center"
          variant="body2"
          className={!vip && safeProgress === 100 ? 'complete' : ''}
        >
          {safeProgress} %
        </Typography>
      </Grid>
    </Grid>
  )
}

export default LinearProgressBar
